import { motion } from "framer-motion";
import { SectionHeading } from "./SectionHeading";

const metrics = [
  { value: "+90 mil", label: "vidas analisadas" },
  { value: "+150 mil", label: "agendamentos realizados" },
  { value: "+6,3 mil", label: "entrevistas por mês" },
  { value: "+336", label: "entrevistas por dia" },
  { value: "15 min", label: "tempo médio por entrevista" },
  { value: "24", label: "atendimentos por analista / dia" },
  { value: "14", label: "analistas em operação diária" },
  { value: "336", label: "atendimentos diários possíveis" },
];

export const Metrics = () => {
  return (
    <section
      id="operacao"
      data-testid="metrics-section"
      className="relative py-20 md:py-28 overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #3636af 0%, #3f5dc7 50%, #4a7ce6 100%)",
      }}
    >
      {/* decorative glow */}
      <div className="absolute -top-32 -left-32 w-[500px] h-[500px] rounded-full bg-[#4a7ce6]/40 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-40 -right-32 w-[520px] h-[520px] rounded-full bg-[#73F2B3]/15 blur-3xl pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.12),transparent_45%)] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <SectionHeading
          overline="Escala operacional"
          title="Estrutura preparada"
          highlight="para escala"
          subtitle="Uma operação desenhada para manter constância, previsibilidade e capacidade de crescimento, inclusive em jornadas estendidas e variações de demanda."
          testid="metrics-heading"
          invert
        />

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {metrics.map((m, idx) => (
            <motion.div
              key={m.label}
              data-testid={`metric-${idx}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{
                duration: 0.5,
                ease: [0.16, 1, 0.3, 1],
                delay: idx * 0.05,
              }}
              className="group relative bg-white/10 backdrop-blur-xl rounded-3xl border border-white/20 p-6 md:p-7 text-center hover:bg-white/15 hover:border-white/40 hover:shadow-[0_18px_44px_rgba(0,0,0,0.25)] transition-all duration-300"
            >
              <div className="text-3xl md:text-4xl font-extrabold tracking-tight text-white leading-none drop-shadow-[0_2px_8px_rgba(0,0,0,0.25)]">
                {m.value}
              </div>
              <div className="mt-3 text-[13px] md:text-sm text-white/80 font-medium leading-snug">
                {m.label}
              </div>
              <div className="mt-5 h-1 w-8 mx-auto rounded-full bg-gradient-to-r from-[#12DDB5] to-[#73F2B3] opacity-70 group-hover:w-14 transition-all duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
